const englishToSpanish = {
  "": "/es",
  "/about-us/contact-us": "/es/contactanos",
  "/banking-privacy-security": "/es/privacidad-y-seguridad",
  "/banking-privacy-security/online-privacy-policy": "/es/privacidad-y-seguridad/privacidad-en-linea",
  "/banking-privacy-security/privacy-faq": "/es/privacidad-y-seguridad/preguntas-frecuentes-sobre-privacidad",
  "/banking-privacy-security/security-faq": "/es/privacidad-y-seguridad/preguntas-frecuentes-sobre-seguridad",
  "/articles": "/es/tu-decides",
  "/articles/banking-101/prepare-for-economic-uncertainties":
    "/es/tu-decides/prepararse-para-las-incertidumbres-economicas",
  "/articles/banking-101/top-budgeting-tips": "/es/tu-decides/mejores-consejos-para-presupuestar",
  "/articles/building-credit/how-to-boost-your-credit-score": "/es/tu-decides/como-aumentar-su-puntaje-crediticio",
  "/articles/consumer-tips/boost-your-savings": "/es/tu-decides/como-lograr-este-objetivo-de-ahorro",
  "/articles/consumer-tips/common-financial-questions-answered":
    "/es/tu-decides/respuestas-a-preguntas-financieras-comunes",
  "/articles/consumer-tips/cutting-costs-around-the-house": "/es/tu-decides/consejos-para-recortar-gastos-en-casa",
  "/articles/consumer-tips/financial-fitness": "/es/tu-decides/como-mantener-finanzas-saludables",
  "/articles/consumer-tips/how-to-write-a-check": "/es/tu-decides/como-escribir-un-cheque",
  "/articles/consumer-tips/what-to-do-with-tax-refund": "/es/tu-decides/que-hacer-con-el-retorno-de-impuestos-anual",
  "/articles/consumer-tips/year-end-good-habits": "/es/tu-decides/termina-anualmente-con-buena-salud-financiera",
  "/articles/family-finance/ideas-financial-literacy-kids": "/es/tu-decides/ensenar-a-los-hijos-sobre-el-dinero",
  "/articles/family-finance/saving-for-college": "/es/tu-decides/ahorrar-para-la-universidad",
  "/articles/home-ownership/best-age-to-buy-a-house": "/es/tu-decides/mejor-edad-para-comprar-una-casa",
  "/articles/home-ownership/closing-costs": "/es/tu-decides/costos-de-cierre",
  "/articles/home-ownership/new-home-checklist": "/es/tu-decides/lista-de-verificacion-de-casa-nueva",
  "/articles/home-ownership/selling-your-home": "/es/tu-decides/vender-su-casa",
  "/business-banking/small-business": "/es/banca-de-negocios",
  "/customer-service/account-details": "/es/detalles-de-la-cuenta",
  "/customer-service/faq": "/es/preguntas-frecuentes",
  "/open-bank-account-online": "/es/abrir-cuenta-bancaria-en-linea",
  "/personal-banking/account-fees": "/es/banca-personal/cargos",
  "/personal-banking/checking-account": "/es/banca-personal/cuenta-de-cheques",
  "/personal-banking/checking-account/interest-rewards-checking": "/es/banca-personal/interest-rewards-checking",
  "/personal-banking/checking-account/rewards-checking": "/es/banca-personal/rewards-checking",
  "/personal-banking/contact-loan-officer": "/es/banca-personal/contacte-a-un-asesor-hipotecario",
  "/personal-banking/credit-cards": "/es/banca-personal/tarjetas-de-credito",
  "/personal-banking/credit-cards/secured-credit-card": "/es/banca-personal/tarjetas-de-credito/secured-credit-card",
  "/personal-banking/free-checking-account": "/es/banca-personal/gratis-cuenta-de-cheques",
  "/personal-banking/fresh-start-second-chance-account": "/es/banca-personal/cuenta-nuevo-comienzo",
  "/personal-banking/home-loans": "/es/banca-personal/prestamos-hipotecarios",
  "/personal-banking/home-loans/closing-cost-checking-account-offer":
    "/es/banca-personal/prestamos-hipotecarios/ahorre-en-costos-de-cierre",
  "/personal-banking/home-loans/homeowner-assistance":
    "/es/banca-personal/prestamos-hipotecarios/asistencia-a-propietarios",
  "/personal-banking/interest-rates": "/es/banca-personal/tasas-de-interes",
  "/personal-banking/login": "/es/banca-personal/entrar",
  "/personal-banking/retirement-ira-accounts": "/es/banca-personal/jubilacion-ira",
  "/personal-banking/rewards-checking-faq":
    "/es/banca-personal/preguntas-frecuentes-sobre-los-rewards-de-cuentas-de-cheques",
  "/personal-banking/savings-account": "/es/banca-personal/cuentas-de-ahorro",
  "/personal-banking/savings-account/cds-tx": "/es/banca-personal/tasas-de-interes-texas",
  "/terms-of-use": "/es/terminos-de-uso",
  "/workplace-banking": "/es/work-perks"
};

module.exports = {
  englishToSpanish
};
